module.exports = __webpack_public_path__ + "media/images/abagail-09b730427ebcfd2d6385cda8815c63d6.png";